import React from 'react';

const Footer = () => {
    return (
        <div className="mt-5 text-center">
            <a href="https://github.com/mdmehedyhassan/genius-car-mechanics-clint" target="_blank" className="btn btn-outline-primary m-2" rel="noopener noreferrer">
                Client site code
            </a>
            <a href="https://github.com/mdmehedyhassan/genius-car-mechanics-server" target="_blank" className="btn btn-outline-primary m-2" rel="noopener noreferrer">
                Server site code
            </a>
            <br />
            <p><small>© Md Mehedy Hassan. 2022 </small></p>
        </div>
    );
};

export default Footer;